import Client from "@/repositories/Client/AxiosClient.js"

const resource = `/api/sms-appliance-remind-rate`

export default {
  list() {
    return Client.get(`${resource}`)
  },
  update(smsApplianceRemindRate) {
    return Client.put(
      `${resource}/${smsApplianceRemindRate.id}`,
      smsApplianceRemindRate,
    )
  },
  create(smsApplianceRemindRate) {
    return Client.post(`${resource}`, smsApplianceRemindRate)
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`)
  },
}
